import { render } from "./AposNotification.vue?vue&type=template&id=64eee6a0&scoped=true"
import script from "./AposNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./AposNotification.vue?vue&type=script&setup=true&lang=js"

import "./AposNotification.vue?vue&type=style&index=0&id=64eee6a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64eee6a0"],['__file',"notification/ui/apos/components/AposNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64eee6a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64eee6a0', __exports__)) {
    api.reload('64eee6a0', __exports__)
  }
  
  module.hot.accept("./AposNotification.vue?vue&type=template&id=64eee6a0&scoped=true", () => {
    api.rerender('64eee6a0', render)
  })

}


export default __exports__